import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from '../redux/TranslationHelper';

const TempOne = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  // 모바일 감지 (window.innerWidth 기준)
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;

  const menuRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  useEffect(() => {
    const checkArrows = () => {
      const el = menuRef.current;
      if (!el) return;
      setShowLeftArrow(el.scrollLeft > 0);
      setShowRightArrow(el.scrollWidth > el.clientWidth + el.scrollLeft);
    };
    checkArrows();
    if (menuRef.current) {
      menuRef.current.addEventListener("scroll", checkArrows);
      window.addEventListener("resize", checkArrows);
    }
    return () => {
      if (menuRef.current) {
        menuRef.current.removeEventListener("scroll", checkArrows);
        window.removeEventListener("resize", checkArrows);
      }
    };
  }, []);

  const scrollMenu = (dir) => {
    const el = menuRef.current;
    if (!el) return;
    const scrollAmount = 100;
    el.scrollBy({ left: dir === "left" ? -scrollAmount : scrollAmount, behavior: "smooth" });
  };

  if (!isMobile) return null;


  const menuItems = [
    { label: t("내 정보"), path: "/mydata" },
    { label: t("자산정보"), path: "/points" },
    { label: t("추천인"), path: "/recommendee" },
    { label: t("계보도"), path: "/legs" },
    { label: t("멤버십투자"), path: "/getmembership" },
    { label: t("수당요약"), path: "/getPaybacks" },
  ];

  return (
    <div style={{ position: "relative", width: "100vw", background: "#fff", zIndex: 9999, borderBottom: "1px solid #ccc" }}>
      {showLeftArrow && (
        <div
          style={{
            position: "absolute", left: 0, top: 0, bottom: 0, width: 32, display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(to right, #fff 80%, transparent)", zIndex: 10000, cursor: "pointer"}}
          onClick={() => scrollMenu("left")}
        >
          ◀
        </div>
      )}
      <div
        ref={menuRef}
        style={{
          overflowX: "auto",
          whiteSpace: "nowrap",
          display: "block",
          textAlign: "center",
          padding: "12px 0",
          fontSize: "16px",
          color: "#000",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <style>{`
          .tempone-menu::-webkit-scrollbar { display: none; }
        `}</style>
        <div className="tempone-menu" style={{ display: "inline-block" }}>
          {menuItems.map((item) => (
            <div
              key={item.path}
              onClick={() => navigate(item.path)}
              style={{
                cursor: "pointer",
                padding: "4px 16px",
                fontWeight: 500,
                display: "inline-block",
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      </div>
      {showRightArrow && (
        <div
          style={{
            position: "absolute", right: 0, top: 0, bottom: 0, width: 32, display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(to left, #fff 80%, transparent)", zIndex: 10000, cursor: "pointer"}}
          onClick={() => scrollMenu("right")}
        >
          ▶
        </div>
      )}
    </div>
  );

};

export default TempOne; 